(ns ballot-scout-v2-frontend.global-stats.events
  (:require
   [ajax.edn :refer [edn-request-format edn-response-format]]
   [ballot-scout-v2-frontend.api-urls :as urls]
   [ballot-scout-v2-frontend.events :as events]
   [ballot-scout-v2-frontend.request-helpers :as request-helpers]
   [day8.re-frame.http-fx]
   [re-frame.core :as rf]))

(rf/reg-event-fx
 ::fetch-ballot-stats
 (fn [{:keys [db]} _]
   {:db (assoc-in db [:global-stats :ballot-stats] :loading)
    ::events/ajax {:method :get
                   :uri (urls/ballot-stats)
                   :format (edn-request-format)
                   :response-format (edn-response-format)
                   :on-success [::fetch-ballot-stats-success]
                   :on-failure [::fetch-ballot-stats-failure]}}))

(rf/reg-event-fx
 ::fetch-ballot-stats-success
 (fn [{:keys [db]} [_ response]]
   {:db (assoc-in db [:global-stats :ballot-stats] response)
    :dispatch [::request-helpers/clear-failed-request [::fetch-ballot-stats]]}))

(rf/reg-event-fx
 ::fetch-ballot-stats-failure
 (fn [{:keys [db]} [_ response]]
   {:db (assoc-in db [:global-stats :ballot-stats] nil)
    :dispatch [::request-helpers/request-failed [::fetch-ballot-stats] response]}))

(rf/reg-event-fx
 ::fetch-dispo-stats
 (fn [{:keys [db]} _]
   {:db (assoc-in db [:global-stats :dispo-stats] :loading)
    ::events/ajax {:method :get
                   :uri (urls/dispo-stats)
                   :format (edn-request-format)
                   :response-format (edn-response-format)
                   :on-success [::fetch-dispo-stats-success]
                   :on-failure [::fetch-dispo-stats-failure]}}))

(rf/reg-event-fx
 ::fetch-dispo-stats-success
 (fn [{:keys [db]} [_ response]]
   {:db (assoc-in db [:global-stats :dispo-stats] response)
    :dispatch [::request-helpers/clear-failed-request [::fetch-dispo-stats]]}))

(rf/reg-event-fx
 ::fetch-dispo-stats-failure
 (fn [{:keys [db]} [_ response]]
   {:db (assoc-in db [:global-stats :dispo-stats] nil)
    :dispatch [::request-helpers/request-failed [::fetch-dispo-stats] response]}))

(rf/reg-event-fx
 ::fetch-election-stats
 (fn [{:keys [db]} _]
   {:db (assoc-in db [:global-stats :election-stats] :loading)
    ::events/ajax {:method :get
                   :uri (urls/election-stats)
                   :format (edn-request-format)
                   :response-format (edn-response-format)
                   :on-success [::fetch-election-stats-success]
                   :on-failure [::fetch-election-stats-failure]}}))

(rf/reg-event-fx
 ::fetch-election-stats-success
 (fn [{:keys [db]} [_ response]]
   {:db (assoc-in db [:global-stats :election-stats] response)
    :dispatch [::request-helpers/clear-failed-request [::fetch-election-stats]]}))

(rf/reg-event-fx
 ::fetch-election-stats-failure
 (fn [{:keys [db]} [_ response]]
   {:db (assoc-in db [:global-stats :election-stats] nil)
    :dispatch [::request-helpers/request-failed [::fetch-election-stats] response]}))

(rf/reg-event-fx
 ::fetch-notys-stats
 (fn [{:keys [db]} _]
   {:db (assoc-in db [:global-stats :notys-stats] :loading)
    ::events/ajax {:method :get
                   :uri (urls/notys-stats)
                   :format (edn-request-format)
                   :response-format (edn-response-format)
                   :on-success [::fetch-notys-stats-success]
                   :on-failure [::fetch-notys-stats-failure]}}))

(rf/reg-event-fx
 ::fetch-notys-stats-success
 (fn [{:keys [db]} [_ response]]
   {:db (assoc-in db [:global-stats :notys-stats] response)
    :dispatch [::request-helpers/clear-failed-request [::fetch-notys-stats]]}))

(rf/reg-event-fx
 ::fetch-notys-stats-failure
 (fn [{:keys [db]} [_ response]]
   {:db (assoc-in db [:global-stats :notys-stats] nil)
    :dispatch [::request-helpers/request-failed [::fetch-notys-stats] response]}))

(rf/reg-event-fx
 ::fetch-subs-stats
 (fn [{:keys [db]} _]
   {:db (assoc-in db [:global-stats :subs-stats] :loading)
    ::events/ajax {:method :get
                   :uri (urls/subs-stats)
                   :format (edn-request-format)
                   :response-format (edn-response-format)
                   :on-success [::fetch-subs-stats-success]
                   :on-failure [::fetch-subs-stats-failure]}}))

(rf/reg-event-fx
 ::fetch-subs-stats-success
 (fn [{:keys [db]} [_ response]]
   {:db (assoc-in db [:global-stats :subs-stats] response)
    :dispatch [::request-helpers/clear-failed-request [::fetch-subs-stats]]}))

(rf/reg-event-fx
 ::fetch-subs-stats-failure
 (fn [{:keys [db]} [_ response]]
   {:db (assoc-in db [:global-stats :subs-stats] nil)
    :dispatch [::request-helpers/request-failed [::fetch-subs-stats] response]}))

(rf/reg-event-fx
 ::fetch-usps-stats
 (fn [{:keys [db]} _]
   {:db (assoc-in db [:global-stats :usps-stats] :loading)
    ::events/ajax {:method :get
                   :uri (urls/usps-stats)
                   :format (edn-request-format)
                   :response-format (edn-response-format)
                   :on-success [::fetch-usps-stats-success]
                   :on-failure [::fetch-usps-stats-failure]}}))

(rf/reg-event-fx
 ::fetch-usps-stats-success
 (fn [{:keys [db]} [_ response]]
   {:db (assoc-in db [:global-stats :usps-stats] response)
    :dispatch [::request-helpers/clear-failed-request [::fetch-usps-stats]]}))

(rf/reg-event-fx
 ::fetch-usps-stats-failure
 (fn [{:keys [db]} [_ response]]
   {:db (assoc-in db [:global-stats :usps-stats] nil)
    :dispatch [::request-helpers/request-failed [::fetch-usps-stats] response]}))

(rf/reg-event-fx
 ::fetch-stats
 (fn [_ [_ tab]]
   {:dispatch [(case tab
                 :ballots   ::fetch-ballot-stats
                 :dispo     ::fetch-dispo-stats
                 :elections ::fetch-election-stats
                 :notys     ::fetch-notys-stats
                 :subs      ::fetch-subs-stats
                 :usps      ::fetch-usps-stats
                 ::fetch-ballot-stats)]}))

(rf/reg-event-fx
 ::global-stats-navigate
 (fn [{:keys [db]} [_ route]]
   (let [{:keys [tab]} (:query-params route)
         {:keys [ballot-stats dispo-stats election-stats notys-stats subs-stats usps-stats]} (:global-stats db)
         fetch-stats? (case (keyword tab)
                        :ballots   (nil? ballot-stats)
                        :dispo     (nil? dispo-stats)
                        :elections (nil? election-stats)
                        :notys     (nil? notys-stats)
                        :subs      (nil? subs-stats)
                        :usps      (nil? usps-stats)
                        (nil? ballot-stats))]
     (when fetch-stats? {:dispatch [::fetch-stats (keyword tab)]}))))
